import { Button, Flex, Menu, Pagination } from '@mantine/core';
import React from 'react';
import { HiOutlineChevronDown } from 'react-icons/hi';
import { ThemeSystem } from '../../../views/my-learning/dashboard/themeColor';

export interface DropdownComponent {
  label: string;
  value: number;
}

interface TPaginationProps {
  data: any;
  activePage: number;
  activeSizePage: number;
  sizePage: DropdownComponent[];
  setActivePage: (data: any) => void;
  setActiveSizePage: (data: any) => void;
  theme?: ThemeSystem;
}

const TPagination: React.FC<TPaginationProps> = ({
  activePage,
  activeSizePage,
  data,
  sizePage,
  setActivePage,
  setActiveSizePage,
  theme
}) => {
  return (
    <Flex justify={'space-between'} align={'center'} wrap={'wrap-reverse'}>
      <Menu trigger="hover" openDelay={100} closeDelay={400}>
        <Menu.Target>
          <Button
            variant={'outline'}
            style={{
              color:
                theme?.type === 'dark'
                  ? theme?.colors?.text
                  : 'rgba(123, 33, 131, 1)',
              borderColor:
                theme?.type === 'dark'
                  ? theme?.colors?.text
                  : 'rgba(123, 33, 131, 1)'
            }}
            radius="md"
            rightSection={<HiOutlineChevronDown />}
          >
            {activeSizePage}
          </Button>
        </Menu.Target>

        <Menu.Dropdown>
          {sizePage.map((item, index) => (
            <Menu.Item
              key={index}
              onClick={() => setActiveSizePage(item.value)}
            >
              {item.label}
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>

      <Pagination
        bg={theme?.colors?.background}
        total={Math.ceil(data.length / activeSizePage)}
        value={activePage}
        onChange={setActivePage}
        siblings={1}
      />
    </Flex>
  );
};

export default TPagination;
